import * as React from "react";

const SvgAddShortcut = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.412 20a8 8 0 0 0 3.043-.6v2.128a10 10 0 0 1-3.043.472c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10q0 .251-.012.5h-2.004q.015-.248.016-.5a8 8 0 1 0-8 8M7.31 16.45l-.9-1.018 6.165-6.978H7.054V7h7.706v8.723h-1.285V9.472zM19.194 23v-3.15h-3.13v-2.1h3.13V14.6h2.087v3.15h3.13v2.1h-3.13V23z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAddShortcut;
